<template>
    <v-tab-item :value="$route.path" class="pa-3">
        <v-toolbar flat height="80">
            <v-spacer></v-spacer>

            <v-col cols="12" sm="3">
                <v-menu
                    :close-on-content-click="true"
                    offset-y
                    max-width="290px"
                >
                    <template v-slot:activator="{ on }">
                        <v-text-field
                            :label="translations.date[lang]"
                            class="mr-4"
                            color="secondary"
                            autocomplete="off"
                            hint="YYYY/DD format"
                            rounded
                            outlined
                            dense
                            clearable
                            hide-details
                            :prepend-inner-icon="icons.mdiCalendarSearch"
                            v-on="on"
                            v-model="date"
                        ></v-text-field>
                    </template>

                    <v-date-picker
                        v-model="date"
                        color="secondary"
                        type="month"
                        no-title
                    ></v-date-picker>
                </v-menu>
            </v-col>
        </v-toolbar>
        <v-row v-if="loading" no-gutters justify="center" align="center">
            <v-progress-circular indeterminate></v-progress-circular>
        </v-row>
        <div v-if="!loading">
            <v-simple-table fixed-header>
                <template v-slot:default>
                <thead>
                    <tr >
                    <th class="text-left" style="width: 50%;">
                        {{ translations.name[lang] }}
                    </th>
                    <th class="text-left">
                        {{ translations.promotional[lang] }}
                    </th>
                    <th class="text-left">
                        {{ translations.transactional[lang] }}
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                    v-for="item in viberMetrics"
                    :key="item.notification_category_name"
                    >
                    <td  style="width: 50%;">{{ item.notification_category_name }}</td>
                    <td>{{ item.total.promotional }}</td>
                    <td>{{ item.total.transactional }}</td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        
        </div>
        <v-row
            v-if="viberMetrics.length === 0 && !loading"
            no-gutters
            justify="center"
            align="center"
        >
        {{ translations.noData[lang] }}
        </v-row>
    </v-tab-item>
</template>

<script>
import { mdiCalendarSearch } from "@mdi/js";
import { mapState, mapMutations, mapActions } from "vuex";
import translations from "@/utils/translations/loyaltyPanel/branchDebt/viberMetrics";
import moment from "moment";

export default {
    name: "ViberMetrics",

    mixins: [translations],

    data() {
        return {
            icons: { mdiCalendarSearch },
            date: "",
        };
    },

    computed: {
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),
        ...mapState("loyaltyPanel/branchDebt", ["viberMetrics"]),

        lang() {
            return this.$route.params.lang;
        },
    },

    methods: {
        ...mapActions("loyaltyPanel/branchDebt", ["getViberMetrics"]),
    },

    watch: {
        date(val) {
            this.getViberMetrics(val);
        },
    },

    mounted() {
        this.date = moment().subtract(1, "months").format("YYYY-MM");
    },
};
</script>
